import { ProductListPage } from '@/features/product/pages/ProductListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_item.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductListPage,
})
